<template>
  <v-dialog v-model="dialog" scrollable persistent width="800">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Nhập danh sách trạng thái
        <v-spacer />
        <v-icon color="white" @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6" style="min-height: 400px">
        <div class="d-flex justify-center align-center" style="height: 100%" v-if="!isPreview">
          <div class="d-flex flex-column align-center" style="gap: 16px">
            <div class="d-flex flex-column justify-center align-center">
              <v-icon large>mdi-file-excel</v-icon>
              <div style="width: 250px" class="text-center">
                Tải lên tệp excel (.xlsx) để khớp trạng thái nhập học theo danh sách có sẵn
              </div>
            </div>
            <div class="d-flex" style="gap: 8px">
              <v-btn outlined @click="onDownloadTemplate">Tải file mẫu</v-btn>
              <v-btn color="admin" class="elevation-0" dark :loading="isSelecting" @click="onButtonClick">
                <v-icon left>mdi-upload</v-icon>Nhập file Excel
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-btn>
            </div>
          </div>
        </div>
        <div class="" v-else>
          <v-data-table
            :items="items"
            :headers="[
              {text: 'Mã hồ sơ', value: 'code'},
              {text: 'Trạng thái', value: 'flag'},
            ]"
          >
            <template v-slot:[`item.flag`]="{item}">
              <v-chip-group>
                <v-chip :color="item.flag | getEnrollmentFlagClor" label small>
                  {{ item.flag | getEnrollmentFlagTitle }}
                </v-chip>
              </v-chip-group>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6" v-if="isPreview">
        <v-btn outlined @click="closeDialog">Huỷ</v-btn>
        <v-btn color="admin" class="white--text" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import readXlsxFile from 'read-excel-file'
import {mapActions} from 'vuex'

const IMPORT_SCHEMA = {
  'Mã hồ sơ (8 ký tự - format text)': {prop: 'code', type: String},
  'Trạng thái (enroll / reserve / closed)': {prop: 'flag', type: String},
}

export default {
  data: () => ({dialog: false, isSelecting: false, selectedFile: null, items: [], isPreview: false}),
  methods: {
    ...mapActions({grantEnrollmentPermBatch: 'cv/grantEnrollmentPermBatch'}),
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    onDownloadTemplate() {
      this.$utils.handleExportExcel(
        [{'Mã hồ sơ (8 ký tự - format text)': '89512464', 'Trạng thái (enroll / reserve / closed)': 'enroll'}],
        'template-enroll-plan',
      )
    },
    onButtonClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        {once: true},
      )
      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {schema: IMPORT_SCHEMA})
      } catch (error) {
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      this.$alert.success('Đã đọc File thành công!')
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.items = results
        this.isPreview = true
      }
      this.$loading.active = false
    },
    async onSubmit() {
      this.$loading.active = true
      try {
        await this.grantEnrollmentPermBatch({items: this.items})
        this.$emit('onRefresh')
        this.$alert.success('Cập nhật thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
  filters: {
    getEnrollmentFlagTitle: v => {
      switch (v) {
        case 'enroll':
          return 'Nhập học'
        case 'reserve':
          return 'Dự khuyết'
        default:
          return 'Đóng'
      }
    },
    getEnrollmentFlagClor: v => {
      switch (v) {
        case 'enroll':
          return 'success'
        case 'reserve':
          return 'warning'
        default:
          return 'error'
      }
    },
  },
}
</script>